import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import { successInRequest, failedRequest } from './actions';

export function* requestOperacaoDiagnostico({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'resumosinterfacesterminais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'resumosinterfacesterminais', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaodiagnostico/OPERACAODIAGNOSTICO_IN_REQUEST',
    requestOperacaoDiagnostico
  ),
  takeLatest('@operacaodiagnostico/RECORD_FILTERING', applyedFilters),
]);
